import * as React from "react";
import { Helmet } from "react-helmet";

import { Container, Segment, Header, Icon } from "../semantic-ui";

const FourOhFourPage = () => (
  <Container text style={{ margin: "40px 0" }}>
    <Helmet title="Invalid URL" />
    <Segment placeholder textAlign="center">
      <Header as="h2" icon>
        <Icon name="search" />
        Invalid URL
        <Header.Subheader>
          The link you clicked on is not valid.
        </Header.Subheader>
      </Header>
    </Segment>
  </Container>
);

export default FourOhFourPage;
